import { defineComponent } from "vue";
export default defineComponent({
    setup: function setup() {
        var handleOpenModelSpecification = function handleOpenModelSpecification() {
            window.open("https://doc.playturbo.cn/ke-wan-gong-ju-huan-fu-bian-ji-qi/huan-fu-bian-ji-qi-shi-yong-zhi-nan/te-shu-gong-neng-3d-mu-ban/3d-mu-ban-ji-chu-gong-neng-jie-shao", "_blank");
        };
        return {
            handleOpenModelSpecification: handleOpenModelSpecification
        };
    }
});
